'use strict'
const merge = require('webpack-merge')
const prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
  NODE_ENV: '"dev"',
  ROOT_API: '"http://localhost:5000"',
  SITE_URL: '"http://localhost:8080"',
  DASHBOARD_URL: '"http://localhost:8081"',
})



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = dhIU
// module chunks = 1